import React, { useContext } from 'react';
import { RegisterContext } from '../../context/companyregister';
import '../../assets/styles/RegisterForm.css';
import { useNavigate } from 'react-router-dom';
const RegisterForm = () => {
 
const navigate = useNavigate();
  const { formData, handleFormDataChange, registerCompany } = useContext(RegisterContext);

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    await registerCompany();
    alert('Company registered successfully!');
  } catch {
    alert('Registration failed!');
  }
};

  return (
    <div className="register-form-container">
      {/* Top Buttons */}
      <div className="top-action-buttons">
        <button type="button" className="btn btn-outline-info">View Agreement</button>
        <button type="button" className="btn btn-info">Branches</button>
      <button type="button" className="btn btn-info" onClick={() => navigate('/moduleaccess')}>
  Module Access
</button>
      </div>

      {/* Form Start */}
      <form className="register-form" onSubmit={handleSubmit}>
        <h2>Magunex Customer Co</h2>

        {/* Row 1 - Co Code, Govt Short Code, Co Name, Co Name FI */}
        <div className="form-grid">
          <div>
            <label>Co Code</label>
            <input type="text" name="coCode" value={formData.coCode || ''} onChange={handleFormDataChange} />
          </div>
         
          <div>
            <label>Co Name <span style={{ color: 'red' }}>*</span></label>
            <input type="text" name="coName" value={formData.coName || ''} onChange={handleFormDataChange} required />
          </div>
          <div>
            <label>Co Name FI <span style={{ color: 'red' }}>*</span></label>
            <input type="text" name="coNameFi" value={formData.coNameFi || ''} onChange={handleFormDataChange} required />
          </div>
        </div>

        {/* Row 2 - Agreement Document, License Key, License No.of Users, Billing Currency, Billing Rate */}
        <div className="form-grid">
<div>
  <label>Agreement Document <span style={{ color: 'red' }}>*</span></label>
  <div className="file-input-container" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <label htmlFor="agreementDoc1" className="choose-file-btn">Choose File</label>
    <input
      type="file"
      id="agreementDoc1"
      name="agreementDoc1"
      style={{ display: 'none' }}
      onChange={handleFormDataChange}
    />
    {/* Show link if URL, else show file name if File, else show "No file chosen" */}
    {formData.agreementDoc1 && typeof formData.agreementDoc1 === 'string' && formData.agreementDoc1.startsWith('http') ? (
      <a href={formData.agreementDoc1} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 8 }}>
        View Document
      </a>
    ) : formData.agreementDoc1 && formData.agreementDoc1.name ? (
      <span style={{ marginLeft: 8 }}>{formData.agreementDoc1.name}</span>
    ) : (
      <span style={{ marginLeft: 8 }}>No file chosen</span>
    )}
  </div>
</div>
          <div>
            <label>License No.of Users <span style={{ color: 'red' }}>*</span></label>
            <input type="number" name="licenseUsers" value={formData.licenseUsers || ''} onChange={handleFormDataChange} required />
          </div>
          <div>
            <label>Billing Currency</label>
            <input type="text" name="billingCurrency" value={formData.billingCurrency || ''} onChange={handleFormDataChange} />
          </div>
          <div>
            <label>Billing Rate / User /Month <span style={{ color: 'red' }}>*</span></label>
            <input type="number" name="billingRate" value={formData.billingRate || ''} onChange={handleFormDataChange} required />
          </div>
        </div>

        {/* Row 3 - Password, Active, Registered Email, License Start Date, License End Date */}
        <div className="form-grid">
          <div>
            <label>Password <span style={{ color: 'red' }}>*</span></label>
            <input type="password" name="password" value={formData.password || ''} onChange={handleFormDataChange} required />
          </div>
<div className="checkbox-vertical">
  <span className="active-label">Active</span>
  <label className="custom-checkbox-label">
    <input
      type="checkbox"
      name="active"
      checked={formData.active || false}
      onChange={e =>
        handleFormDataChange({
          target: { name: 'active', value: e.target.checked },
        })
      }
    />
    <span className="custom-checkmark"></span>
  </label>
</div>
          <div>
            <label>Registered Email <span style={{ color: 'red' }}>*</span></label>
            <input type="email" name="registeredEmail" value={formData.registeredEmail || ''} onChange={handleFormDataChange} required />
          </div>
          <div>
            <label>License Start Date <span style={{ color: 'red' }}>*</span></label>
            <input type="date" name="licenseStartDate" value={formData.licenseStartDate || ''} onChange={handleFormDataChange} required />
          </div>
          <div>
            <label>License End Date <span style={{ color: 'red' }}>*</span></label>
            <input type="date" name="licenseEndDate" value={formData.licenseEndDate || ''} onChange={handleFormDataChange} required />
          </div>
        </div>

        {/* Row 4 - Agreement Document, Agreement Time Stamp, Patient Code Start From, Service Bill No. Start From, Product Bill No. Start From */}
        <div className="form-grid">

          <div>
            <label>Agreement Time Stamp <span style={{ color: 'red' }}>*</span></label>
            <input type="datetime-local" name="agreementTimeStamp" value={formData.agreementTimeStamp || ''} onChange={handleFormDataChange} required />
          </div>
          <div>
            <label>Patient Code Start From <span style={{ color: 'red' }}>*</span></label>
            <input type="text" name="patientCodeStart" value={formData.patientCodeStart || ''} onChange={handleFormDataChange} required />
          </div>
          <div>
            <label>Service Bill No. Start From <span style={{ color: 'red' }}>*</span></label>
            <input type="text" name="serviceBillStart" value={formData.serviceBillStart || ''} onChange={handleFormDataChange} required />
          </div>
          <div>
            <label>Product Bill No. Start From <span style={{ color: 'red' }}>*</span></label>
            <input type="text" name="productBillStart" value={formData.productBillStart || ''} onChange={handleFormDataChange} required />
          </div>
        </div>

        {/* Row 5 - Billing Card No., Name In Card, Exp MM/YY, CVV */}
        <div className="form-grid">
          <div>
            <label>Billing Card No. <span style={{ color: 'red' }}>*</span></label>
            <input type="text" name="billingCardNo" value={formData.billingCardNo || ''} onChange={handleFormDataChange} required />
          </div>
          <div>
            <label>Name In Card <span style={{ color: 'red' }}>*</span></label>
            <input type="text" name="nameInCard" value={formData.nameInCard || ''} onChange={handleFormDataChange} required />
          </div>
          <div>
            <label>Exp MM/YY <span style={{ color: 'red' }}>*</span></label>
            <input type="text" name="expMMYY" value={formData.expMMYY || ''} onChange={handleFormDataChange} required />
          </div>
          <div>
            <label>CVV <span style={{ color: 'red' }}>*</span></label>
            <input type="text" name="cvv" value={formData.cvv || ''} onChange={handleFormDataChange} required />
          </div>
        </div>

        {/* Submit Button */}
        <div className="submit-button-container">
          <button type="submit" className="submit-btn">Submit &rarr;</button>
        </div>
      </form>
    </div>
  );
};

export default RegisterForm;